import con from "../../../../../connection";
export var authoritiesDetail = function (url) { return function (id) {
    return {
        get: function () { return con.get(url + "/" + id, {}); },
        editDirect: function (request) { return con.post(url + "/" + id, request); },
        editForm: function (request) { return con.post(url + "/" + id, request); },
    };
}; };
export default authoritiesDetail;
